import { render } from "./Wallet.vue?vue&type=template&id=8087f122&scoped=true"
import script from "./Wallet.vue?vue&type=script&setup=true&lang=js"
export * from "./Wallet.vue?vue&type=script&setup=true&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=8087f122&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8087f122"],['__file',"src/components/Wallet/Wallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8087f122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8087f122', __exports__)) {
    api.reload('8087f122', __exports__)
  }
  
  module.hot.accept("./Wallet.vue?vue&type=template&id=8087f122&scoped=true", () => {
    api.rerender('8087f122', render)
  })

}


export default __exports__